import { render, staticRenderFns } from "./icon-chat.vue?vue&type=template&id=20d67116&scoped=true"
import script from "./icon-chat.vue?vue&type=script&lang=js"
export * from "./icon-chat.vue?vue&type=script&lang=js"
import style0 from "./icon-chat.vue?vue&type=style&index=0&id=20d67116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d67116",
  null
  
)

export default component.exports